import { useQuery } from '@tanstack/react-query';
import type { CurrentUser } from '@flarecode/shared';
import { api } from '../lib/api';

export const CURRENT_USER_QUERY_KEY = ['auth', 'me'] as const;

/**
 * TanStack Query hook for the current session user. Returns `null` when
 * anonymous, `CurrentUser` when authenticated, and `undefined` while loading.
 *
 * Cached 30s stale so normal navigation doesn't hammer /api/auth/me.
 * Invalidate after login / logout to force a refresh.
 */
export function useCurrentUser(): {
  user: CurrentUser | null | undefined;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: () => api.me(),
    staleTime: 30_000,
    // Anonymous is a perfectly valid response; don't retry on 401.
    retry: false,
  });
  return { user: data?.user, isLoading };
}
